// extracted by mini-css-extract-plugin
export var boxItems = "_aa-1";
export var boxItemsLg = "_aa-2";
export var button = "_aa-7";
export var buttonHoverless = "_aa-9";
export var buttonLg = "_aa-8";
export var filterGroupBox = "_aa-0";
export var icon = "_aa-3";
export var iconSecondary = "_aa-6";
export var iconWrapper = "_aa-4";
export var iconWrapperLg = "_aa-5";
export var truncatedLabel = "_aa-a";